import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash';

class KeywordExamples extends React.Component{

    constructor(props){
      super(props);
    }

    render(){
      var {onClick} = this.props;
      var examples = ['car insurance', 'buy a house', 'first sales hire'];

      return ReactDOM.createPortal(<div>
        Ex: {_.map(examples, (example, i) => {
          return (<span key={i}><a href="#" onClick={(e) => {onClick(example);}}>{example}</a>{i < examples.length-1 ? ', ' : ''}</span>)
        })}
      </div>, document.getElementById('keyword-examples'));
    }

}

export default KeywordExamples